import styles from "../styles/Footer.module.css"

import Address from "../components/playbook/Address"
import Button from "../components/playbook/Button"
import Body from "../components/playbook/Body"
import Flex from "../components/playbook/Flex"
import FlexItem from "../components/playbook/FlexItem"

type FooterProps = {
  domain: string
}

const Footer = (props: FooterProps) => (
  <footer>
    <Flex
        align={"start"}
        className={styles.hero}
        padding={"lg"}
        wrap
    >
      <FlexItem marginY={"md"} paddingX={"lg"}>
        <img
            alt={props.domain === "streaminnovations" ? "Stream Innovations Logo" : "Stream Financial Logo"}
            src={props.domain == "streaminnovations" ? "/images/stream-innovations-logo-dark-bg.png" : "/images/stream-financial-logo.png"}
            className={styles.footerLogo}
            width={"120"}
        />
      </FlexItem>
      <FlexItem grow>
        <Flex
            align={"stretch"}
            justify={"between"}
            wrap
        >
          <Flex
            align={"stretch"}
            className={styles.contactInfo}
            marginY={"md"}
            orientation={"column"}
            gap={"sm"}
            paddingX={"lg"}
          >
            <Body
                className={styles.contactTitle}
                text={"Contact Us"}
            />
            <Body text={"610-922-1070"} />
            <Body text={`customerservice@${props.domain}.com`} />
            <Address
                address={"PO Box 460"}
                city={"Newtown Square"}
                state={"PA"}
                zipcode={"19073-0460"}
            />
            <Body
                aria={{label: "N M L S number two four five seven nine three eight"}}
                text={"NMLS#2457938"}
            />
          </Flex>

          <Flex
            align={"stretch"}
            className={styles.contactInfo}
            marginY={"md"}
            orientation={"column"}
            paddingX={"lg"}
          >
            <Body
                className={styles.contactTitle}
                paddingBottom={"sm"}
                text={"Customer Support Hours"}
            />
            <Body text={"Monday - Thursday: 8am - 7pm Eastern Time"} />
            <Body text={"Friday: 8am - 5pm Eastern Time"} />
          </Flex>

          <Flex
            marginY={"md"}
            orientation={"column"}
          >
            <Body
                dark
                paddingX={"lg"}
                text={"Disclosures"}
            />
            <Button
                className={styles.docLink}
                link={"/docs/esign.pdf"}
                newWindow
                paddingX={"lg"}
                text={"E Sign"}
                variant={"link"}
            />
            <Button
                className={styles.docLink}
                link={"/docs/credit_authorization.pdf"}
                newWindow
                paddingX={"lg"}
                text={"Credit Authorization"}
                variant={"link"}
            />
            <Button
                className={styles.docLink}
                link={"/docs/privacy.pdf"}
                newWindow
                paddingX={"lg"}
                text={"Privacy Statement"}
                variant={"link"}
            />
             <Button
                className={styles.docLink}
                link={"/docs/mobile-terms-of-service.pdf"}
                newWindow
                paddingX={"lg"}
                text={"Mobile Terms of Service"}
                variant={"link"}
            />
            <Button
                className={styles.docLink}
                link={"/docs/regulatory_information"}
                newWindow
                paddingX={"lg"}
                text={"Regulatory Information"}
                variant={"link"}
            />
          </Flex>
        </Flex>
      </FlexItem>
    </Flex>
  </footer>
)

export default Footer
